import React, { FC, useState, useEffect, useContext } from 'react'
import { notify } from 'react-notify-toast'
import { isMobile } from 'react-device-detect'
import history from '../../history'
import cookie from 'react-cookies'
import { useLocation } from 'react-router-dom'

import GenericBackgroundLayer from '../../GenericComponents/GenericBackgroundLayer'
import NavigationBar from '../NavigationBar/NavigationBar'
import GenericTextSpan from '../../GenericComponents/GenericTextSpan'
import GenericMainCard from '../../GenericComponents/GenericMainCard'
import GenericSwitch from '../../GenericComponents/GenericSwitch'
import GenericButton from '../../GenericComponents/GenericButton'
import GenericLogo from '../../GenericComponents/GenericLogo'
import GenericMobileTopNavigation from '../../GenericComponents/GenericMobileTopNavigation'
import GenericRow from '../../GenericComponents/GenericRow'
import Loader from '../Loader/Loader'

import { usePromiseTracker, trackPromise } from 'react-promise-tracker'

import ChangeTrainingDays from '../AddUserScreen/views/WizzardPage5'

import {
  getUserData,
  getUserStripeBoughtPackages,
  getStripePaidContent,
  getMissingSteps,
  getPromoInfo,
} from '../../Api/backendApi'
import AppContext from '../../context/appContext'
import { arrayRemove } from '../../utils/ArrayHelpers'
import GenericInput from '../../GenericComponents/GenericInput'
import GenericColumn from '../../GenericComponents/GenericColumn'

import SplashScreenBox from './SplashScreen.jsx'

import { SplashScreenContainer, BackgroundMask } from './SplashScreenStyle'

interface SplashScreenInterface {}

const SplashScreen: FC<SplashScreenInterface> = ({}) => {
  const appContext = useContext(AppContext)
  const location = useLocation()
  const { promiseInProgress } = usePromiseTracker()
  const [user, setUser] = useState(Object)
  const [missingSteps, setMissingSteps] = useState(undefined)
  const [promoInfo, setPromoIfno] = useState(null)

  useEffect(() => {
    obtainUser()
    obtainMissingSteps()
    obtainPromoInfo()
  }, [])

  useEffect(() => {
    if (user && Object.keys(user).length !== 0 && missingSteps !== undefined) {
      redirectUser()
    }
  }, [user, missingSteps])

  const obtainMissingSteps = async () => {
    let missingSteps: any = await trackPromise(getMissingSteps())

    missingSteps && setMissingSteps(missingSteps.missing_steps)
  }

  const obtainUser = async () => {
    const user = await trackPromise(getUserData())
    setUser(user)
  }

  const obtainPromoInfo = async () => {
    const promoInfo = await getPromoInfo()

    await setPromoIfno(promoInfo)
  }

  const redirectUser = () => {
    // if (!cookie.load("userSelectedMiazga") && !cookie.load("userSelectedChallenge") && missingSteps !== undefined && missingSteps && missingSteps.length !== 0) {
    //   history.replace('/wybierz-wersje')
    //   return
    // }

    // user wybrał miazgę

    // user nie jest demo i nie mama suba

    if (
      !user.has_subscription &&
      !user.has_nutshell_challenge &&
      (!cookie.load('userDemoMode') || cookie.load('userDemoMode') == undefined)
    ) {
      history.replace({ pathname: '/wybierz-plan/sub' })
      return
    }

    // user jest demo lub ma suba
    if (
      user.has_subscription ||
      user.has_nutshell_challenge ||
      cookie.load('userDemoMode')
    ) {
      // spr czy user ma missing steps
      if (
        missingSteps !== undefined &&
        missingSteps &&
        missingSteps.length !== 0
      ) {
        if (user.show_intro) {
          history.replace('/witaj')
          return
        } else {
          history.replace('/o-tobie')
          return
        }
      } else {
        history.replace('/trening')
        return
      }
    }
  }

  return (
    <SplashScreenContainer>
      {promiseInProgress && <Loader />}
      <BackgroundMask />
    </SplashScreenContainer>
  )
}

export default SplashScreen
